/**
 * Copyright (C) 2016 Egylis,
 * Siège social, 46 rue René Clair, 75892 PARIS cedex 18 - France.
 * All Rights Reserved.
 *
 * E-mail : info@egylis.com
 *
 * This software is the confidential and proprietary information
 * of Egylis. ("Confidential Information"). You shall not
 * disclose such Confidential Information and shall use it only
 * in accordance with the terms of the license agreement you
 * entered into with Egylis.
 *
 * Created by calvez on 13/09/16.
 *
 * Version : Generator 2.0.9
 */

import {AfterContentInit, Directive, ElementRef, Input} from '@angular/core';
import {FileStatus} from '../msa/entity';
import {MpaService} from '../mpa';
import {LogService} from '../log';


@Directive({
    selector: '[moMediaSrcCache]'
})
export class MoMediaSrcCacheDirective implements AfterContentInit {
    /**
     * Media Path
     */
    private _mediaPath: string;
    /**
     * If done
     */
    protected _done: boolean = false;
    /**
     * If doing
     */
    private _doing: boolean = false;
    /**
     * Content inited
     */
    protected _contentInited: boolean = false;
    /**
     * Mode local : we search the media in the device
     */
    private _local: boolean = true;
    /**
     *  Mode local : we search the media on the web
     */
    private _online: boolean = true;
    /**
     * Mode needToDownloadIfNotLocal : if the media is not local, wa had it in the synchro
     */
    private _needToDownloadIfNotLocal: boolean = true;

    constructor(
        protected el: ElementRef,
        private mpaService: MpaService,
        private logService: LogService
    ) {
        this.logService.logLog('*** MoMediaSrcCacheDirective - constructor', 'MoMediaSrcCacheDirective', 'constructor', 3);
    }

    /**
     * ngAfterContentInit
     */
    public ngAfterContentInit() {
        this.logService.logLog('*** MoMediaSrcCacheDirective - ngAfterContentInit', 'MoMediaSrcCacheDirective', 'ngAfterContentInit', 3);
        this._contentInited = true;
        if (!this._done) {
            if (!this._doing) {
                this._doing = true;
                this.logService.logLog('*** MoMediaSrcCacheDirective - ngAfterContentInit ** DO ' + this._mediaPath,
                    'MoMediaSrcCacheDirective', 'ngAfterContentInit', 3);
                if (this._mediaPath != null && this._mediaPath !== '') {
                    this.mpaService.getFile(this._mediaPath, this._local, this._online, this._needToDownloadIfNotLocal)
                        .then(
                            (succ) => {
                                switch (succ.file_status) {
                                    case FileStatus.ERROR:
                                        // Mettre une image Error
                                        this.el.nativeElement.src = 'assets/images/exclamation.png';
                                        this._doing = false;
                                        break;
                                    case FileStatus.FOUND_BUT_NOT_DOWNLOADED:
                                        // Mettre une image non télécharger
                                        this.el.nativeElement.src = 'assets/images/cloudDownload.png';
                                        this._doing = false;
                                        break;
                                    case FileStatus.NOT_FOUND:
                                        // Mettre une image 404
                                        this.el.nativeElement.src = 'assets/images/question.png';
                                        this._doing = false;
                                        break;
                                    case FileStatus.OK:
                                    case FileStatus.ONLINE:
                                        this.el.nativeElement.src = succ.uri;
                                        this.el.nativeElement.hidden = false;
                                        this._done = true;
                                        this._doing = false;
                                        break;
                                }
                            },
                            () => {
                                // Mettre une image Error
                                this._doing = false;
                            }
                        );
                } else {
                    // Mettre une image vide
                    this._doing = false;
                }
            }
        }
    }


    /**
     * Getter.
     */
    public get mediaPath(): string {
        return this._mediaPath;
    }

    /**
     * Setter.
     * @param value
     */
    @Input()
    public set mediaPath(value: string) {
        this._mediaPath = value;
        this.logService.logLog('*** MoMediaSrcCacheDirective - SET mediaPath' + this._mediaPath,
            'MoMediaSrcCacheDirective', 'mediaPath', 3);
        if (this._contentInited) {
            this._done = false;
            this.ngAfterContentInit();
        }
    }

    /**
     * Setter.
     * @param value
     */
    @Input()
    public set local(value: boolean) {
        this._local = value;
    }

    /**
     * Setter.
     * @param value
     */
    @Input()
    public set online(value: boolean) {
        this._online = value;
    }

    /**
     * Setter.
     * @param value
     */
    @Input()
    public set needToDownloadIfNotLocal(value: boolean) {
        this._needToDownloadIfNotLocal = value;
    }
}
